(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("c0xNe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "shouldShowSearchResults", function () { return $ac510052bcf48908$export$bd13de3de2290b57; });
$parcel$export(module.exports, "shouldShowNoSearchResults", function () { return $ac510052bcf48908$export$51fb654feebeb96; });
$parcel$export(module.exports, "default", function () { return $ac510052bcf48908$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $cvrvk = parcelRequire("cvrvk");

const $ac510052bcf48908$var$SearchForm = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("4NQNB")));
const $ac510052bcf48908$export$bd13de3de2290b57 = (hideAC, acResults)=>{
    return !hideAC && acResults && !!(acResults.areas.length || acResults.counties.length || acResults.municipalities.length || acResults.estates.length);
};
const $ac510052bcf48908$export$51fb654feebeb96 = (hideAC, acResults)=>{
    return !hideAC && acResults && !(acResults.areas.length || acResults.counties.length || acResults.municipalities.length || acResults.estates.length);
};
const $ac510052bcf48908$var$AutocompleteStartpageComponent = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $cvrvk.default), {}),
        children: /*#__PURE__*/ (0, $a9eYm.jsx)($ac510052bcf48908$var$SearchForm, {
            shouldShowSearchResults: $ac510052bcf48908$export$bd13de3de2290b57,
            shouldShowNoSearchResults: $ac510052bcf48908$export$51fb654feebeb96
        })
    });
};
var $ac510052bcf48908$export$2e2bcd8739ae039 = $ac510052bcf48908$var$AutocompleteStartpageComponent;

});
parcelRegister("cvrvk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afd7b67e6e5790c7$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $afd7b67e6e5790c7$var$SearchFormFallback = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "flex flex-col items-center gap-1 lg:grid lg:grid-cols-[4fr_2fr_2fr_1fr] lg:bg-grey50 lg:mt-1 mb-1 lg:px-4 lg:py-3 lg:rounded-[60px] lg:h-[77px]",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "flex items-center gap-3 lg:gap-4 psuedo-border-after bg-grey50 px-4 lg:pl-1 rounded-3xl w-full h-[47px]",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        src: "/images/Icons/location-blue.svg",
                        alt: "Omr\xe5de",
                        className: "w-5 h-auto grayscale"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "flex flex-col w-full",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                className: "lg:flex items-center hidden rounded-md w-28 font-ic text-grey200 text-sm",
                                children: "Vart vill du bo?"
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                className: "py-1 rounded-md w-full font-ic text-grey200 text-sm lg:text-base",
                                children: "S\xf6k efter kommun, l\xe4n, omr\xe5de eller adress"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "flex items-center gap-3 lg:gap-4 bg-grey50 px-4 rounded-3xl w-full h-[47px]",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        src: "/images/Icons/SearchStartPage/estate-type-icon.svg",
                        alt: "Bostadstyp",
                        className: "w-5 h-auto grayscale"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "flex flex-col w-full",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                className: "lg:block hidden font-ic text-grey200 text-sm",
                                children: "Hur vill du bo?"
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                                className: "flex justify-between lg:hidden py-1 rounded-md w-full text-grey200 text-sm",
                                children: [
                                    "Hur vill du bo?",
                                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                        className: "w-[10px] h-auto transition-all duration-75",
                                        src: "/images/Icons/Arrows/arrow-down-simple-black500.svg",
                                        alt: "pil"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                                className: "lg:flex lg:gap-4 hidden py-1 rounded-md w-full text-base text-grey200",
                                children: [
                                    "V\xe4lj bostadstyp",
                                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                        className: "w-[10px] h-auto transition-all duration-75",
                                        src: "/images/Icons/Arrows/arrow-down-simple-black500.svg",
                                        alt: "pil"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "relative lg:before:top-1/2 lg:before:-left-[18px] lg:before:absolute flex items-center lg:before:content-[''] gap-3 lg:gap-4 bg-grey50 lg:before:bg-grey100 px-4 rounded-3xl w-full lg:before:w-[1px] h-[47px] lg:before:h-5/6 lg:before:-translate-y-1/2",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        src: "/images/Icons/SearchStartPage/room-icon.svg",
                        alt: "Antal rum",
                        className: "w-5 h-auto grayscale"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "flex flex-col w-full",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                className: "lg:block hidden font-ic text-grey200 text-sm",
                                children: "Minst antal rum"
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                                className: "flex justify-between lg:hidden py-1 rounded-md w-full text-grey200 text-sm",
                                children: [
                                    "Minst antal rum",
                                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                        className: "w-[10px] h-auto transition-all duration-75",
                                        src: "/images/Icons/Arrows/arrow-down-simple-black500.svg",
                                        alt: "pil"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                                className: "lg:flex lg:gap-4 hidden py-1 rounded-md w-full text-base text-grey200",
                                children: [
                                    "V\xe4lj antal rum",
                                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                        className: "w-[10px] h-auto transition-all duration-75",
                                        src: "/images/Icons/Arrows/arrow-down-simple-black500.svg",
                                        alt: "pil"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "flex justify-center items-center bg-grey300 mt-1 lg:mt-0 rounded-3xl w-full h-[44px]",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "font-icb text-white",
                        children: "S\xf6k"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        width: "16",
                        height: "16",
                        className: "ml-3 w-4",
                        src: "/Images/Icons/search-icon.svg",
                        alt: "S\xf6k"
                    })
                ]
            })
        ]
    });
};
var $afd7b67e6e5790c7$export$2e2bcd8739ae039 = $afd7b67e6e5790c7$var$SearchFormFallback;

});

parcelRegister("4NQNB", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("5CTT0")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("74Z0M")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("9qKJc"))
]).then(()=>parcelRequire("iEIlo"));

});


})();
//# sourceMappingURL=AutocompleteStartpageComponent.322ae21f.js.map
